export enum IdentificacaoCpfCnpj {
    Cpf = '0',
    Cnpj = '1',
    Exterior = '2'
}

export const descricaoIdentificacaoCpfCnpj: { [key: string]: string } = {
    [IdentificacaoCpfCnpj.Cpf]: "CPF",
    [IdentificacaoCpfCnpj.Cnpj]: "CNPJ",
    [IdentificacaoCpfCnpj.Exterior]: "Exterior"
};

export const selectIdentificacaoCpfCnpj: any[] = [
    { tipo: IdentificacaoCpfCnpj.Cpf, nome: descricaoIdentificacaoCpfCnpj[IdentificacaoCpfCnpj.Cpf] },
    { tipo: IdentificacaoCpfCnpj.Cnpj, nome: descricaoIdentificacaoCpfCnpj[IdentificacaoCpfCnpj.Cnpj] },
    { tipo: IdentificacaoCpfCnpj.Exterior, nome: descricaoIdentificacaoCpfCnpj[IdentificacaoCpfCnpj.Exterior] }
];
